import { useEffect, useState } from "react";

export function useIsVisible(
  targetRef: React.RefObject<HTMLElement | null>,
  rootRef: React.RefObject<HTMLElement | null>
) {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    if (targetRef.current && rootRef.current) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIntersecting(
            entry.isIntersecting &&
              entry.intersectionRect.height /
                (entry.rootBounds?.height ?? Infinity) >=
                0.5
          );
        },
        { root: rootRef.current, threshold: makeThresholds() }
      );

      observer.observe(targetRef.current);
      return () => {
        observer.disconnect();
      };
    }
  }, [targetRef, rootRef]);

  return isIntersecting;
}

function makeThresholds() {
  const thresholds: number[] = [];
  for (let i = 0; i < 1; i += 0.1) {
    thresholds.push(i);
  }
  return thresholds;
}
